export const labelDashboardBanner =
    {
        "labelBanner": {
            "en": "Nutrient Removal Calculator",
            "es": "Calculador de Remoción de Nutrientes",
            "fr": "Calculateur des exportations en éléments nutritifs",
            "pt": "Calculadora de Remoção de Nutrientes",
            "ru": "Калькулятор выноса элементов питания",
            "zh": "移除养分计算器"
        }
    };

export const labelDashboardLeftMenu =
    {
        "labelCrops": {
            "en": "Crops",
            "es": "Cultivos",
            "fr": "Cultures",
            "pt": "Culturas",
            "ru": "Культуры",
            "zh": "作物"
        },
        "labelSettings": {
            "en": "Settings",
            "es": "Configuración",
            "fr": "Configurations",
            "pt": "Configurações",
            "ru": "Настройки",
            "zh": "设置"
        },
        "labelMathPref": {
            "i":
                {
                    "en": "Imperial/US",
                    "es": "Imperial (EUA)",
                    "fr": "Imperial/US",
                    "pt": "Imperial (US)",
                    "ru": "Английская (США)",
                    "zh": "英制（美制）"
                },
            "m":
                {
                    "en": "Metric",
                    "es": "Métrico",
                    "fr": "Métrique",
                    "pt": "Métrico",
                    "ru": "Метрическая",
                    "zh": "公制"
                }
        },
        "labelAbout": {
            "en": "Learn More",
            "es": "Más información",
            "fr": "Plus d'information",
            "pt": "Saiba mais",
            "ru": "Узнать больше",
            "zh": "关于"
        },
        "labelMathPreference": {
            "en": "Unit of Measurement",
            "es": "Unidad de medida",
            "fr": "Unité de mesure",
            "pt": "Unidade de medida",
            "ru": "Единицы измерения",
            "zh": "测量单位"
        }

    };
